import { Optional } from '@/generic/functional';
import { Severity } from '@/rule/domain/Rule.ts';
import { RuleStatus } from '@/rule/domain/RuleStatus.ts';
import { RulesScope } from '@/rule/domain/RulesScope.ts';

export type RulesFilter = {
  text: Optional<string>;
  scope: RulesScope;
  status: Optional<RuleStatus>;
  severity: Optional<Severity>;
};

export const RulesFilter = {
  none: (): RulesFilter => ({
    text: Optional.empty(),
    scope: RulesScope.all(),
    status: Optional.empty(),
    severity: Optional.empty(),
  }),
};
